import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const MarkdownMessage = ({ content, isUser }) => {
  return (
    <div className="prose prose-sm md:prose-base dark:prose-invert max-w-none">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          // Paragraphs
          p: ({ node, ...props }) => (
            <p className="mb-3 last:mb-0 leading-relaxed" {...props} />
          ),
          // Bold text
          strong: ({ node, ...props }) => (
            <strong className="font-bold" {...props} />
          ),
          // Italic text
          em: ({ node, ...props }) => (
            <em className="italic" {...props} />
          ),
          // Unordered lists
          ul: ({ node, ...props }) => (
            <ul className="list-disc list-inside mb-3 space-y-1 ml-2" {...props} />
          ),
          // Ordered lists
          ol: ({ node, ...props }) => (
            <ol className="list-decimal list-inside mb-3 space-y-1 ml-2" {...props} />
          ),
          // List items
          li: ({ node, ...props }) => (
            <li className="leading-relaxed" {...props} />
          ),
          // Code blocks
          code: ({ node, inline, ...props }) => {
            if (inline) {
              return (
                <code
                  className="px-1.5 py-0.5 rounded bg-gray-200 dark:bg-dark-bg-tertiary text-sm font-mono"
                  {...props}
                />
              );
            }
            return (
              <code
                className="block p-3 rounded-lg bg-gray-100 dark:bg-dark-bg text-gray-900 dark:text-gray-100 text-sm font-mono overflow-x-auto mb-3"
                {...props}
              />
            );
          },
          // Headings
          h1: ({ node, ...props }) => (
            <h1 className="text-2xl font-bold mb-3 mt-4 first:mt-0" {...props} />
          ),
          h2: ({ node, ...props }) => (
            <h2 className="text-xl font-bold mb-3 mt-4 first:mt-0" {...props} />
          ),
          h3: ({ node, ...props }) => (
            <h3 className="text-lg font-bold mb-2 mt-3 first:mt-0" {...props} />
          ),
          // Blockquotes
          blockquote: ({ node, ...props }) => (
            <blockquote
              className="border-l-4 border-gray-300 dark:border-[#2e2e2d] pl-4 italic my-3"
              {...props}
            />
          ),
          // Links
          a: ({ node, ...props }) => (
            <a
              className="text-primary hover:underline"
              target="_blank"
              rel="noopener noreferrer"
              {...props}
            />
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownMessage;
